import { useDeletedReservations } from '@/hooks/api-hooks';
import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconTrash } from '@tabler/icons-react';
import type { Business, DeletedReservation } from '@turizi/shared';
import SimpleReservationsList from './simple-reservations-list';

interface Props {
    business?: Business;
    client_id_business?: number | string;
}

export default function BusinessDeletedReservationsTab({
    business,
    client_id_business,
}: Props): JSX.Element {
    const { t } = useTranslation();

    const businessId = client_id_business ?? business?.id;

    const {
        data: deletedData,
        isLoading,
    } = useDeletedReservations(
        { business_id: businessId },
        { enabled: !!businessId }
    );

    const deletedReservations: DeletedReservation[] = deletedData?.data || [];

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2.5 mb-2 border-b border-slate-100 pb-2">
                <div className="p-1.5 bg-red-50 rounded-lg text-red-600 shrink-0">
                    <IconTrash size={16} stroke={2} />
                </div>
                <div className="flex items-center gap-2 flex-1">
                    <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">{t('deleted_reservations')}</h3>
                    {isLoading && <Loader size="xs" color="black" />}
                </div>
            </div>

            {!isLoading && (
                <SimpleReservationsList
                    deletedReservations={deletedReservations}
                />
            )}
        </div>
    );
}
